module.exports = __webpack_public_path__ + "static/img/01bg.6ff0c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/07planLibrary/01bg.png
// module id = CL+y
// module chunks = 0